import Activate from "./Activate/index.js";
import Suspend from "./Suspend/index.js";
class Index {
    rc;
    _parent;
    webhookId;
    constructor(_parent, webhookId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.webhookId = webhookId;
    }
    path(withParameter = true) {
        if (withParameter && this.webhookId !== null) {
            return `${this._parent.path()}/webhooks/${this.webhookId}`;
        }
        return `${this._parent.path()}/webhooks`;
    }
    /**
     * Returns the list of all webhooks associated with the current account.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/webhooks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns webhooks(s) with the specified id(s).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/webhooks/{webhookId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        if (this.webhookId === null) {
            throw new Error("webhookId must be specified.");
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a webhook by ID.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/webhooks/{webhookId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async delete(restRequestConfig) {
        if (this.webhookId === null) {
            throw new Error("webhookId must be specified.");
        }
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    suspend() {
        return new Suspend(this);
    }
    activate() {
        return new Activate(this);
    }
}
export default Index;
